export interface CourseDeclarationLabel {
  key: string;
  code: string;
  description: string;
}

/** Boolean course declaration flags -> display code + description */
export const COURSE_DECLARATION_LABELS: CourseDeclarationLabel[] = [
  {
    key: 'lateLoad',
    code: 'LL',
    description: 'Horse requires a late load.',
  },
  {
    key: 'assistedLoad',
    code: 'SM',
    description: 'A member of staff to be at the start to assist with loading.',
  },
  {
    key: 'earlyStart',
    code: 'SE',
    description: 'Horse to go to start early.',
  },
  {
    key: 'withdrawnPlateShed',
    code: 'WA',
    description: 'Horse is to be withdrawn if any plate is shed/removed at the start.',
  },
  {
    key: 'withdrawnForelegPlateShed',
    code: 'WF',
    description: 'Horse is to be withdrawn if a plate on a foreleg is shed/removed at the start.',
  },
  {
    key: 'redHood',
    code: 'RH',
    description: 'Horse will be wearing a red hood to start.',
  },
  {
    key: 'redHoodInParadeRing',
    code: 'RHP',
    description: 'Horse will be wearing a red hood in the parade ring.',
  },
  {
    key: 'withdrawnTongueStrap',
    code: 'WT',
    description: 'Horse is to be withdrawn if the declared tongue strap cannot be fastened.',
  },
  {
    key: 'earPlugsRemovedAtStart',
    code: 'EPO',
    description: 'Horse will be wearing earplugs which should be removed at the start.',
  },
  {
    key: 'runInEarPlugs',
    code: 'EPI',
    description: 'Horse will wear earplugs throughout the race.',
  },
  {
    key: 'fedOnCourse',
    code: 'FC',
    description: 'Horse is to be fed on the course.',
  },
  {
    key: 'mountedInChute',
    code: 'MC',
    description: 'Horse is to be mounted in the chute.',
  },
];
